module.exports = __webpack_public_path__ + "media/images/help/flow/bg-rail-02-d96ec0b0ac30c4e687967839889a9009.svg";